export default {
  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns
  accountType: "Account Type",
  balance: "Balance (USDT)",

  // Empty state
  noWalletData: "No wallet balance data parsed from current investigation file",

  // Download
  downloadDetails: "Download Details",
  downloadFileName: "Data Details",
};
